import { SubscriptionLike as ISubscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { LanguageService } from '../services/language.service';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
})
export class AdminComponent implements OnInit, OnDestroy {
  private adminLanguageKey: string;
  private subscribe: ISubscription;

  constructor(
    private readonly cookieService: CookieService,
    private readonly configService: ConfigService,
    private readonly languageService: LanguageService
  ) {}

  ngOnInit() {
    this.adminLanguageKey = this.configService.configData.cookieAdminLanguageKey;
    const currentLocale = this.cookieService.get(this.adminLanguageKey);
    if (!currentLocale) {
      const cookieExpiresDate = moment().add(1, 'year').toDate();
      this.subscribe = this.languageService
        .getDefaultLanguage()
        .subscribe((l) => {
          this.cookieService.set(
            this.adminLanguageKey,
            l.code,
            cookieExpiresDate
          );
        });
    }
  }
  ngOnDestroy() {
    if (this.subscribe) {
      this.subscribe.unsubscribe();
    }
  }
}
